/*

  q r  a r  l a u n c h
  QRARLaunch

  :description:
  A class to assist with rendering QR codes.

*/

//
//  :code:
import { MESSAGE_GROUP_QR, PLATFORM_QR, QR_TYPE_DELIVERY, QR_TYPE_SCAN } from "../statics";
import EyekandyARLaunch from "../_abstract/EyekandyARLaunch";

export default class QRARLaunch extends EyekandyARLaunch {

  constructor(options) {
    super(options)
    this.platform = PLATFORM_QR
    this.group = MESSAGE_GROUP_QR
  }

  //
  //  :api:
  //  Public API to be used by external callers.
  //  -   =   -   =   -   =   -   =   -   =   -   =   -   =   -   =   -   =   -   =   -   =   -   =   -   =   -   =   -

  delivery(service, arid, environment, distributor, session, user, type, margin) {
    if (!type) {
      type = "svg"
    }
    //
    //  Validate the inputs are valid before continuing.
    this._validateEnvironmentAndARIDAndService(environment, arid, service)
    //
    //  Render our URL.
    const deliveryURL = this._renderQRServiceURL(
      service, arid, environment, QR_TYPE_DELIVERY, distributor, session, user, type, margin
    )
    //
    //  Return the URL.
    return deliveryURL
  }

  scan(service, arid, environment, distributor, session, user) {
    //
    //  Validate the inputs are valid before continuing.
    this._validateEnvironmentAndARIDAndService(environment, arid, service)
    //
    //  Render our URL.
    const scanURL = this._renderQRServiceURL(service, arid, environment, QR_TYPE_SCAN, distributor, session, user)
    //
    //  Return the URL.
    return scanURL
  }


  //
  //  :internal:
  //  Functions internal to the class, enums etc.
  //  -   =   -   =   -   =   -   =   -   =   -   =   -   =   -   =   -   =   -   =   -   =   -   =   -   =   -   =   -

  _renderQRServiceURL(service, arid, environment, mode, distributor, session, user, type, margin) {
    //
    //  Render our base URL, TODO: BASE_URL selection.
    let url = `https://qr.pointandplace.com/${mode}/${arid}`
    if (type === "png") {
      //
      //  TODO: Deploy this change into production.
      url += `/qr.${type}` // Changed from /png to allow for deducation of type by callers.
      url = url.replace("https://qr", "https://qr-dev")
    }
    //
    //  Render our get arguments and add them to the URL.
    const getArgs = {
      c: service,
      u: user,
      s: session,
      d: distributor
    }
    if (!isNaN(margin)) {
      getArgs.margin = margin;
    }
    /* istanbul ignore next */
    if (getArgs.c || getArgs.u || getArgs.s || getArgs.d) { url += "?" }
    for (const [k, v] of Object.entries(getArgs)) {
      if (typeof v !== "undefined" && v !== null) {
        url += `${k}=${v}&`
      }
    }
    if (environment === "staging" || environment === "dev") {
      url += `staging=yes`
    }
    //
    //  Trim the final character if it's an ampersand.
    url = url.replace(/&$/, '');
    //
    //  Return the complete url to the caller.
    return url
  }

}
